const FitCarvingDetailSection = () => {
  return (
    <section className="py-16 md:py-24 bg-white px-4">
      <div className="max-w-6xl mx-auto">
        {/* メインタイトル */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-serif font-semibold text-dark-gray mb-4">
            Fit Carving（フィットカービング）
          </h2>
          <p className="text-lg md:text-xl text-gold font-medium">
            30分で腹筋約41,000回分の効果
          </p>
        </div>

        {/* Fit Carvingとは */}
        <div className="mb-16 md:mb-20">
          <div className="bg-gradient-to-br from-light-gold to-white rounded-3xl p-8 md:p-12 shadow-sm">
            <h3 className="text-2xl md:text-3xl font-bold text-dark-gray mb-6 text-center">
              国内で唯一エビデンスが取れている痩身機器
            </h3>
            <div className="prose prose-lg max-w-none text-dark-gray/80">
              <p className="text-base md:text-lg leading-relaxed mb-4">
                Fit Carvingは「パルス電磁界」という磁気の力で身体に磁界を届けることができます。これによって直接インナーマッスルを激しく収縮させ、通常の時間のかかる運動による脂肪燃焼を体内に発生させます。
              </p>
              <p className="text-base md:text-lg leading-relaxed">
                従来の電気（EMS）とは違い、磁気により筋収縮を起こさせますので、電気（EMS）では不可能な筋収縮を起こさせ脂肪を燃焼させます。わずか30分の短時間で筋収縮約41,000回以上の運動を実現します。
              </p>
            </div>
          </div>
        </div>

        {/* 5つの特徴 */}
        <div className="mb-16 md:mb-20">
          <h3 className="text-2xl md:text-3xl font-bold text-dark-gray mb-10 text-center">
            Fit Carvingの5つの特徴
          </h3>
          <div className="grid md:grid-cols-2 gap-6 md:gap-8">
            {/* 特徴1 */}
            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-md border border-light-gold/30">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-gold rounded-full flex items-center justify-center text-white font-bold text-xl mr-4">
                  1
                </div>
                <h4 className="text-lg md:text-xl font-bold text-dark-gray">
                  圧倒的なパワー
                </h4>
              </div>
              <p className="text-dark-gray/80 leading-relaxed">
                他社様の同タイプ磁場パルス式痩身マシンに比べても圧倒的なパワーを誇ります。30分の装着で約41,000回の筋収縮を行うことができます。
              </p>
            </div>

            {/* 特徴2 */}
            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-md border border-light-gold/30">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-gold rounded-full flex items-center justify-center text-white font-bold text-xl mr-4">
                  2
                </div>
                <h4 className="text-lg md:text-xl font-bold text-dark-gray">
                  即効性のある効果
                </h4>
              </div>
              <p className="text-dark-gray/80 leading-relaxed">
                効果が施術後にすぐ出ますので、1回でも変化を実感していただけます。本当に見た目に変化がすぐ現れるので、多くのお客様に喜ばれております。
              </p>
            </div>

            {/* 特徴3 */}
            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-md border border-light-gold/30">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-gold rounded-full flex items-center justify-center text-white font-bold text-xl mr-4">
                  3
                </div>
                <h4 className="text-lg md:text-xl font-bold text-dark-gray">
                  施術が簡単
                </h4>
              </div>
              <p className="text-dark-gray/80 leading-relaxed">
                画面はスタートボタンを押したらあとは自動運転。ハンドピースを動かすなど専門性や経験が必要な動作はありません。寝ているだけで効果を実感できます。
              </p>
            </div>

            {/* 特徴4 */}
            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-md border border-light-gold/30">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-gold rounded-full flex items-center justify-center text-white font-bold text-xl mr-4">
                  4
                </div>
                <h4 className="text-lg md:text-xl font-bold text-dark-gray">
                  骨盤底筋ケア
                </h4>
              </div>
              <p className="text-dark-gray/80 leading-relaxed">
                骨盤底筋強化モードは普段なかなか鍛えることができない産後のケアや尿漏れに対して、専用イスに腰掛けるだけで女性特有のお悩みにアプローチします。
              </p>
            </div>

            {/* 特徴5 */}
            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-md border border-light-gold/30">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-gold rounded-full flex items-center justify-center text-white font-bold text-xl mr-4">
                  5
                </div>
                <h4 className="text-lg md:text-xl font-bold text-dark-gray">
                  フェムケア対応
                </h4>
              </div>
              <p className="text-dark-gray/80 leading-relaxed">
                今話題のフェムケアや女性のデリケートゾーンの状態を健康維持する膣トレモード、尿トレモードを搭載。女性の悩みや健康管理にとても効果的です。
              </p>
            </div>

            {/* AYAアンバサダー */}
            <div className="bg-gradient-to-br from-gold/10 to-light-gold rounded-2xl p-6 md:p-8 shadow-md border-2 border-gold/50">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-gold rounded-full flex items-center justify-center mr-4">
                  <i className="ri-star-fill text-white text-2xl"></i>
                </div>
                <h4 className="text-lg md:text-xl font-bold text-dark-gray">
                  AYAがアンバサダー
                </h4>
              </div>
              <p className="text-dark-gray/80 leading-relaxed">
                フィットネスプロデューサーのAYAがアンバサダーを務める抜群の話題性！美容と健康に焦点をおいた磁場パルスで、衰えた筋肉の強化、リバウンドしづらい美ボディーを実現します。
              </p>
            </div>
          </div>
        </div>

        {/* 対応部位 */}
        <div className="mb-16 md:mb-20">
          <h3 className="text-2xl md:text-3xl font-bold text-dark-gray mb-10 text-center">
            施術可能な部位
          </h3>
          <div className="bg-gradient-to-br from-light-gold to-white rounded-3xl p-8 md:p-12">
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
              {[
                { icon: 'ri-heart-pulse-line', text: 'お腹' },
                { icon: 'ri-heart-pulse-line', text: 'おしり' },
                { icon: 'ri-heart-pulse-line', text: '太もも' },
                { icon: 'ri-heart-pulse-line', text: '二の腕' },
                { icon: 'ri-heart-pulse-line', text: '骨盤底筋群' },
                { icon: 'ri-heart-pulse-line', text: 'ふくらはぎ' },
              ].map((item, index) => (
                <div
                  key={index}
                  className="flex items-center bg-white rounded-xl p-4 shadow-sm"
                >
                  <div className="w-10 h-10 flex items-center justify-center bg-gold/10 rounded-full mr-3">
                    <i className={`${item.icon} text-gold text-xl`}></i>
                  </div>
                  <span className="text-dark-gray font-medium">{item.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* こんな方におすすめ */}
        <div className="mb-16 md:mb-20">
          <h3 className="text-2xl md:text-3xl font-bold text-dark-gray mb-10 text-center">
            こんな方におすすめ
          </h3>
          <div className="grid md:grid-cols-2 gap-4 md:gap-6">
            {[
              '楽して筋トレしたい方',
              '太りやすい体質の方',
              '加齢によって太りやすくなった方',
              '足腰の衰えが気になる方',
              '産後の体型が気になる方',
              'ぽっこりお腹を引き締めたい方',
              '美尻・くびれを作りたい方',
              '骨盤底筋を鍛えたい方',
              '尿漏れが気になる方',
              '運動する時間がない方',
            ].map((text, index) => (
              <div
                key={index}
                className="flex items-center bg-white rounded-xl p-4 shadow-sm border border-light-gold/30"
              >
                <div className="w-6 h-6 flex items-center justify-center bg-gold rounded-full mr-3 flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-dark-gray">{text}</span>
              </div>
            ))}
          </div>
        </div>

        {/* 安全性 */}
        <div className="mb-16 md:mb-20">
          <h3 className="text-2xl md:text-3xl font-bold text-dark-gray mb-10 text-center">
            安全面も万全
          </h3>
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-md border border-light-gold/30">
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-gold/10 rounded-full mr-4 flex-shrink-0">
                  <i className="ri-shield-check-line text-gold text-2xl"></i>
                </div>
                <div>
                  <h4 className="text-lg font-bold text-dark-gray mb-2">
                    空水冷システム搭載
                  </h4>
                  <p className="text-dark-gray/80 leading-relaxed">
                    マシン搭載の空水冷システムにより、稼働熱による冷却時間が必要ではなく、長時間の連続使用が安全に可能です。
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-gold/10 rounded-full mr-4 flex-shrink-0">
                  <i className="ri-alarm-warning-line text-gold text-2xl"></i>
                </div>
                <div>
                  <h4 className="text-lg font-bold text-dark-gray mb-2">
                    自動シャットダウン機能
                  </h4>
                  <p className="text-dark-gray/80 leading-relaxed">
                    もし何らかの理由でマシンが熱を持つなど故障した場合、自動シャットダウン機能が働きますので事故なども防げます。
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-gold/10 rounded-full mr-4 flex-shrink-0">
                  <i className="ri-time-line text-gold text-2xl"></i>
                </div>
                <div>
                  <h4 className="text-lg font-bold text-dark-gray mb-2">
                    痛みなし・ダウンタイムなし
                  </h4>
                  <p className="text-dark-gray/80 leading-relaxed">
                    寝ているだけで筋肉を鍛えることができ、痛みもダウンタイムもありません。施術後すぐに日常生活に戻れます。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 実際の声 */}
        <div>
          <h3 className="text-2xl md:text-3xl font-bold text-dark-gray mb-10 text-center">
            お客様の実際の声
          </h3>
          <div className="grid md:grid-cols-2 gap-6 md:gap-8">
            <div className="bg-gradient-to-br from-light-gold to-white rounded-2xl p-6 md:p-8 shadow-sm">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-gold rounded-full flex items-center justify-center text-white font-bold mr-3">
                  A
                </div>
                <div>
                  <p className="font-bold text-dark-gray">40代女性</p>
                  <p className="text-sm text-dark-gray/60">産後の体型が気になる</p>
                </div>
              </div>
              <p className="text-dark-gray/80 leading-relaxed">
                「自分が動いて運動しなくても鍛えられるということでとても好評です！実際に筋肉が動いているなと感じてFit Carvingをお腹にご利用しています。」
              </p>
            </div>

            <div className="bg-gradient-to-br from-light-gold to-white rounded-2xl p-6 md:p-8 shadow-sm">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-gold rounded-full flex items-center justify-center text-white font-bold mr-3">
                  B
                </div>
                <div>
                  <p className="font-bold text-dark-gray">30代女性</p>
                  <p className="text-sm text-dark-gray/60">楽して筋トレしたい</p>
                </div>
              </div>
              <p className="text-dark-gray/80 leading-relaxed">
                「即効性を感じてもらうことで、コースの期待感を感じてもらいやすくなりました。本当に見た目に変化がすぐ現れるので、多くのお客様に喜ばれております。」
              </p>
            </div>

            <div className="bg-gradient-to-br from-light-gold to-white rounded-2xl p-6 md:p-8 shadow-sm">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-gold rounded-full flex items-center justify-center text-white font-bold mr-3">
                  C
                </div>
                <div>
                  <p className="font-bold text-dark-gray">50代女性</p>
                  <p className="text-sm text-dark-gray/60">骨盤底筋ケア</p>
                </div>
              </div>
              <p className="text-dark-gray/80 leading-relaxed">
                「骨盤底筋強化専用イスに腰掛けるだけで女性特有のお悩みにアプローチできて、姿勢や腰痛などさまざまなトラブル解決にも効果を感じています。」
              </p>
            </div>

            <div className="bg-gradient-to-br from-light-gold to-white rounded-2xl p-6 md:p-8 shadow-sm">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-gold rounded-full flex items-center justify-center text-white font-bold mr-3">
                  D
                </div>
                <div>
                  <p className="font-bold text-dark-gray">60代女性</p>
                  <p className="text-sm text-dark-gray/60">足腰の衰えが気になる</p>
                </div>
              </div>
              <p className="text-dark-gray/80 leading-relaxed">
                「加齢によって太りやすくなり、足腰の衰えも気になっていましたが、Fit Carvingで楽に筋力アップができて、体が軽くなりました。」
              </p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-16 text-center">
          <p className="text-dark-gray/80 mb-6">
            ※効果には個人差があります
          </p>
          <a
            href="#reservation"
            className="inline-block bg-gold text-white px-12 py-4 rounded-full font-bold text-lg hover:bg-gold/90 transition-colors shadow-lg whitespace-nowrap"
          >
            Fit Carvingを体験する
          </a>
        </div>
      </div>
    </section>
  );
};

export default FitCarvingDetailSection;
